<template>
  <BaseModal
    :is-visible="isVisible"
    @hideModal="hideModal()"
    :size="'xl'"
    :is-editable="false"
    :is-archivable="false"
  >
    <template #header>
      {{ $t('routes.EXABOrganizationLeadCreate') }}
    </template>
    <template #body>
      <create :idStatus="idStatus" :idUserData="idUserData"></create>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import Create from '@/components/Dashboard/Views/AgreementsBundle/exaborganizationlead/Create'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'OrganizationLeadCreateModal',
  props: ['idStatus', 'idUserData'],
  components: {
    BaseModal,
    Create
  },
  computed: {
    ...mapGetters({
      isVisible: 'exaborganizationlead/createModal/isVisible',
      created: 'exaborganizationlead/create/created'
    })
  },
  watch: {
    created (val) {
      if (val) {
        this.hideModal()
        this.$emit('organizationLeadCreated')
      }
    }
  },
  methods: {
    hideModal () {
      this.reset()
      this.toggleModal()
    },
    ...mapMutations({
      toggleModal: 'exaborganizationlead/createModal/toggleModal'
    }),
    ...mapActions({
      reset: 'exaborganizationlead/create/reset'
    })
  }
}
</script>

<style scoped>

</style>
